<template>
    <transition name="bounce-up">
        <div id="ahoo-update-warning-dialog" v-if="isShowWarning">
            <div class="img">
                <img src="@/assets/img/ahoo-update-icon.png" style="image-rendering: -webkit-optimize-contrast" alt="" />
            </div>
            <div class="msg">
                <div>有新的版本了！</div>
            </div>
            <div class="actions">
                <span class="btn" @click="handleCancelBtnClick">稍後</span>
                <span class="btn primary" v-if="!isUpdating" @click="handleUpdateBtnClick">更新</span>
                <span class="btn primary" v-if="isUpdating">更新中...</span>
            </div>
        </div>
    </transition>
</template>
<script>
import axios from 'axios';

export default {
    name: 'UpdateChecker',
    components: {},
    data() {
        return {
            checkTime: 3 * 60 * 1000, // 確認時間間距
            waitTimeAfterCanceled: 10 * 60 * 1000,
            isShowWarning: false,
            timer: null,
            currVer: null,
            latestVer: null,
            isUpdating: false,
        };
    },
    methods: {
        handleUpdateBtnClick() {
            this.isUpdating = true;
            setTimeout(() => {
                window.location.reload();
            }, 2);
        },

        handleCancelBtnClick() {
            this.isShowWarning = false;
            this.endCheckTimer();
            setTimeout(() => {
                this.startCheckTimer();
            }, this.waitTimeAfterCanceled);
        },

        // 開啟版本確認計時器
        startCheckTimer() {
            this.check();
            this.timer = setInterval(() => {
                // 視窗使用中
                if (!document.hidden && !this.isShowWarning) {
                    this.check();
                }
            }, this.checkTime);
        },

        // 關閉版本確認計時器
        endCheckTimer() {
            if (this.timer) {
                clearInterval(this.timer);
            }
        },

        // 確認版本主要動作
        check() {
            // 設定版本資訊網址
            const { host } = window.location;
            let verUrl = `${host}/ver.json?t=${new Date().getTime()}`;
            if (host === 'localhost:8080') {
                verUrl = `http://${verUrl}`;
            } else {
                verUrl = `https://${verUrl}`;
            }

            // 取得版本資訊
            axios({
                url: verUrl,
                method: 'GET',
            }).then((resp) => {
                this.isShowWarning = this.checkIfNeedUpdate(resp.data.version);
            });
        },

        // 與當前版本比對，判斷是否需要更新
        checkIfNeedUpdate(versionTxt) {
            // eslint-disable-next-line global-require, import/no-unresolved, import/no-absolute-path
            const pjson = require('/package.json');

            this.currVer = pjson.version;
            this.latestVer = versionTxt;

            const currVerNum = this.versionTxtToNumber(this.currVer);
            const latestVerNum = this.versionTxtToNumber(this.latestVer);

            if (currVerNum && latestVerNum) {
                if (currVerNum < latestVerNum) {
                    return true;
                }
            }
            return false;
        },

        // 版本號碼文字轉為數字，供比較新舊使用
        // 1.16.5-1 => 1016005.01
        versionTxtToNumber(versionTxt) {
            const fix = versionTxt.split('-');
            const parts = versionTxt.split('.');
            return parseInt(parts[0], 10) * 1000000 + parseInt(parts[1], 10) * 1000 + parseInt(parts[2], 10) + parseInt(fix[1], 10) * 0.01;
        },
    },
    mounted() {
        this.startCheckTimer();
    },
    beforeDestroy() {
        this.endCheckTimer();
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/main.scss";

.bounce-up-enter-active {
    animation: bounce-up-in 0.5s;
}

.bounce-up-leave-active {
    animation: bounce-up-in 0.5s reverse;
}

@keyframes bounce-up-in {
    0% {
        transform: translateY(150px);
    }

    50% {
        transform: translateY(-10px);
    }

    100% {
        transform: translateY(0px);
    }
}

#ahoo-update-warning-dialog {
    position: fixed;
    bottom: 15px;
    left: 15px;
    background-color: $main-color;
    color: #fff;
    font-size: 11pt;
    z-index: 999999;
    padding: 15px 15px 15px 140px;
    border-radius: 20px;
    box-shadow: 4px 4px 15px #463cb255;

    > .img {
        position: absolute;
        top: 12px;
        left: 15px;

        img {
            display: block;
            width: 110px;
            margin: 0 auto;
        }
    }

    > .msg {
        font-weight: bold;
        text-align: left;
        padding: 0 0 5px 0;
        min-height: 55px;

        .link {
            color: #fff;
            font-size: 10pt;
        }
    }

    > .actions {
        margin: 10px 0 0 -3px;
        text-align: left;

        > .btn {
            display: inline-block;
            background-color: #ffffff99;
            line-height: 30px;
            height: 30px;
            padding: 0 15px;
            margin: 3px;
            font-size: 10pt;
            font-weight: bold;
            color: $main-color;
            border-radius: 5px;
            transition: 0.2s;
            cursor: pointer;
            text-align: center;

            &:hover {
                background-color: #ffffffcc;
            }

            &.primary {
                min-width: 100px;
                background-color: $primary-color;
                color: $main-color;

                &:hover {
                    background-color: $primary-color-dim;
                }
            }
        }
    }

    @media print {
        display: none;
    }
}
</style>
